// Single source of truth for SettingsPage's tab values, so deep links can't drift from what it renders.
export const SETTINGS_TABS = [
  "limits-points",
  "pricing-catalog",
  "events",
  "stamps-referral",
  "windows-expiry",
  "appointments",
  "mobile-apps",
  "store-visibility",
] as const;

export type SettingsTab = (typeof SETTINGS_TABS)[number];

// Named handles for each tab, derived from SETTINGS_TABS so call sites can't drift from it.
export const [
  TAB_LIMITS_POINTS,
  TAB_PRICING_CATALOG,
  TAB_EVENTS,
  TAB_STAMPS_REFERRAL,
  TAB_WINDOWS_EXPIRY,
  TAB_APPOINTMENTS,
  TAB_MOBILE_APPS,
  TAB_STORE_VISIBILITY,
] = SETTINGS_TABS;

export function isSettingsTab(value: string): value is SettingsTab {
  return (SETTINGS_TABS as readonly string[]).includes(value);
}

export function settingsPath(tab?: SettingsTab): string {
  return tab ? `/settings?tab=${tab}` : "/settings";
}
